import React, { forwardRef } from 'react'

import {
  errorClasses,
  getBoxShadowClasses,
  helperClasses,
  inputBaseClasses,
  labelClasses,
} from '@/app/components/Form/styles'
import { cn } from '@/app/utils/style'

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string
  error?: string
  helperText?: string
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, error, helperText, className, id, required, rows = 4, ...props }, ref) => {
    const textareaId = id || `textarea-${label?.toLowerCase().replace(/\s+/g, '-')}`

    return (
      <div className="flex flex-col gap-sm">
        {label && (
          <label htmlFor={textareaId} className={cn(labelClasses)}>
            {label}
            {required && <span className="text-red-500 ml-xs">*</span>}
          </label>
        )}
        <textarea
          ref={ref}
          id={textareaId}
          rows={rows}
          className={cn(
            inputBaseClasses,
            'lg:rounded-lg resize-none',
            getBoxShadowClasses(error),
            className,
          )}
          aria-invalid={error ? 'true' : 'false'}
          aria-describedby={
            error ? `${textareaId}-error` : helperText ? `${textareaId}-helper` : undefined
          }
          required={required}
          onFocus={(e) => {
            props.onFocus?.(e)
          }}
          onBlur={(e) => {
            props.onBlur?.(e)
          }}
          {...props}
        />

        {error && (
          <span id={`${textareaId}-error`} className={errorClasses}>
            {error}
          </span>
        )}
        {!error && helperText && (
          <span id={`${textareaId}-helper`} className={helperClasses}>
            {helperText}
          </span>
        )}
      </div>
    )
  },
)

Textarea.displayName = 'Textarea'
